<div class="px-4 py-3 flex justify-content-between align-items-center w-100" [ngClass]="variant">
  <button
    pButton
    class="p-button p-button-primary p-button-outlined small icon-only"
    [style.visibility]="isBackButtonVisible ? 'visible' : 'hidden'"
    (click)="backClicked()">
    <shared-icon icon="triangle-left" height="1rem" width="1rem" />
  </button>

  <h2
    class="bold-800 text-center"
    [ngClass]="{ 'text-18': titleSize === 'small', 'text-24': titleSize === 'medium' }">
    {{ headline }}
  </h2>

  @if (isMenuVisible) {
    <cp-multiaction-button
      buttonClass="small {{ variant === 'better-deal' ? 'color-light' : '' }}"
      [menuItems]="menuItems" />
  } @else if (isActionButtonVisible) {
    <button
      pButton
      class="p-button p-button-primary p-button-outlined small icon-only"
      (click)="emitActionClicked()">
      <shared-icon
        [icon]="actionIcon"
        [height]="actionIconSize ?? '1.25rem'"
        [width]="actionIconSize ?? '1.25rem'" />
    </button>
  } @else {
    <button
      class="p-button"
      [style.visibility]="isMenuVisible || isActionButtonVisible ? 'visible' : 'hidden'"></button>
  }
</div>
